<template>
  <div>
    <v-text-field
      :dir="dir"
      :rules="rules"
      :label="label"
      v-model="innerValue"
      :readonly="readOnly"
      variant="outlined"
      :type="keyboardType"
      :hint="hint"
      :hide-details="readOnly ? 'true' : 'auto'"
    >
    </v-text-field>
    <!-- نمایش واحد پول -->
    <div
      v-if="isCurrency && !!innerValue"
      class="text-secondary text-caption w-100 text-left"
    >
      {{ Intl.NumberFormat('fa-IR').format(innerValue) }}
    </div>
  </div>
</template>

<script>
export default {
  name: "TextInput",

  props: {
    modelValue: {
      type: [String, Number],
      default: null
    },
    label: String,
    hint: String,
    isRequired: Boolean,
    dir: String,
    readOnly: Boolean,
    keyboardType: String,
    isCurrency: Boolean
  },

  data() {
    return {
      innerValue: this.modelValue
    }
  },

  computed: {
    rules() {
      return this.isRequired ? [(value) => !!value || "الزامی"] : []
    }
  },

  watch: {
    modelValue(val) {
      this.innerValue = val
    },
    innerValue(val) {
      this.$emit("update:modelValue", val)
    }
  }
}
</script>
